import React from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import styles from "./massengermodal.module.css";
import SafeImgModule, { SafeImg as SafeImgNamed } from "./SafeImg";

const resolveComponent = (mod, named) => {
  if (typeof mod === "function") return mod;
  if (mod && typeof mod.default === "function") return mod.default;
  if (typeof named === "function") return named;
  if (named && typeof named.default === "function") return named.default;
  return () => null;
};

const SafeImg = resolveComponent(SafeImgModule, SafeImgNamed);

const LeftSectionChatItem = ({
  item,
  isSelected,
  isOwnShop,
  nameText,
  statusText,
  avatarSrc,
  unreadCount,
  handleListItemClick,
  handleOpenChatForProfile,
}) => (
  <div
    className={`${styles.chatItem} ${isSelected ? styles.chatItemSelected : ""}`}
    onClick={() => handleListItemClick(item)}
  >
    <div className={styles.chatItemMain}>
      <div className={styles.chatInfo}>
        <SafeImg
          src={avatarSrc}
          alt="User"
          className={styles.leftprofileImage}
        />
        <div className={styles.chatItemText}>
          <span
            className={styles.chatName}
            style={{
              fontWeight: isSelected ? "700" : "500",
              color: isSelected ? "#0084ff" : "#222",
            }}
          >
            {nameText}
          </span>
          <p className={styles.chatMessage}>{statusText}</p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        {isOwnShop && (
          <button
            type="button"
            className={styles.openChatButton}
            aria-label={`Open chat with ${nameText}`}
            title={`Open chat with ${nameText}`}
            onClick={(event) => {
              event.stopPropagation();
              handleOpenChatForProfile(item);
            }}
          >
            <ChatBubbleOutlineIcon />
          </button>
        )}
        {unreadCount > 0 && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              background: "#e53935",
              color: "#fff",
              borderRadius: "12px",
              width: "24px",
              height: "24px",
              fontSize: "12px",
              minWidth: "24px",
              textAlign: "center",
            }}
          >
            {unreadCount}
          </div>
        )}
      </div>
    </div>
  </div>
);

export { LeftSectionChatItem };
export default LeftSectionChatItem;
